// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const ThreeDotsIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 256 64">
          <g fill="inherit" transform="translate(-6327 -10716)"><circle cx="32" cy="32" r="32" transform="translate(6519 10716)"/><circle cx="32" cy="32" r="32" transform="translate(6423 10716)"/><circle cx="32" cy="32" r="32" transform="translate(6327 10716)"/></g>
        </svg>
      )
    }
  </Icon>
);

export default ThreeDotsIcon;
